import React, { useState, useContext, useEffect } from "react";
import {
  Grid,
  Typography,
  Divider,
  Card,
  ButtonGroup,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import DashboardContext from "../../../context/dashboard/DashboardContext";

const TopStores = () => {
  const dashboardContext = useContext(DashboardContext);
  const { getDashboardTopStores, stores } = dashboardContext;
  const [loading, setLoading] = useState(false);
  const [daySelected, setDaySelected] = useState("Today");
  const [dayButtonColor, setDayButtonColor] = useState({
    todayBG: "#ffffff",
    todayText: "normal",
    yesterdayBG: "#ffffff",
    yesterdayText: "normal",
  });

  useEffect(() => {
    if (daySelected) {
      if (daySelected === "Today") {
        setDayButtonColor({
          todayBG: "#dddddd",
          todayText: "bold",
          yesterdayBG: "#ffffff",
          yesterdayText: "normal",
        });
      } else if (daySelected === "Yesterday") {
        setDayButtonColor({
          todayBG: "#ffffff",
          todayText: "normal",
          yesterdayBG: "#dddddd",
          yesterdayText: "bold",
        });
      }
    }
  }, [daySelected]);

  const useStyles = makeStyles((theme) => ({
    card: {
      backgroundColor: "#FFFFFF",
      height: 350,
    },
    header: {
      backgroundColor: theme.palette.primary.dark,
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      height: 50,
    },
    headerText: {
      color: theme.palette.primary.contrastText,
    },
    body: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(1),
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    var from = "";
    var to = "";
    setLoading(true);
    if (daySelected === "Today") {
      from = new Date(new Date().setHours(8, 0, 0, 0)).toISOString();
      to = new Date(new Date().setHours(32, 0, 0, 0)).toISOString();
    } else if (daySelected === "Yesterday") {
      from = new Date(new Date().setHours(-16, 0, 0, 0)).toISOString();
      to = new Date(new Date().setHours(8, 0, 0, 0)).toISOString();
    }
    getDashboardTopStores(from, to);
    //eslint-disable-next-line
  }, [daySelected]);

  useEffect(() => {
    if (stores) {
      setLoading(false);
    }
  }, [stores]);

  return (
    <Card className={classes.card}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.header}
      >
        <Grid item>
          <Typography variant="h6" className={classes.headerText}>
            Top Campaigns(Excluded Facebook) - By Revenue{" "}
          </Typography>{" "}
        </Grid>{" "}
        <Grid
          item
          style={{
            width: "50%",
          }}
        >
          {" "}
          {/* <ButtonGroup style={{ width: "100%" }}>
                        <Button
                          style={{
                            width: "50%",
                            backgroundColor: dayButtonColor.todayBG,
                            fontWeight: dayButtonColor.todayText,
                          }}
                          size="small"
                          className={classes.buttonOutline}
                          variant="outlined"
                          disabled={loading}
                          onClick={() => setDaySelected("Today")}
                        >
                          Today
                        </Button>
                        <Button
                          style={{
                            width: "50%",
                            backgroundColor: dayButtonColor.yesterdayBG,
                            fontWeight: dayButtonColor.yesterdayText,
                          }}
                          size="small"
                          className={classes.buttonOutline}
                          variant="outlined"
                          disabled={loading}
                          onClick={() => setDaySelected("Yesterday")}
                        >
                          Yesterday
                        </Button>
                      </ButtonGroup> */}{" "}
        </Grid>{" "}
      </Grid>{" "}
      {stores && loading === false ? (
        <Grid
          container
          direction="row"
          className={classes.body}
          style={{
            height: "90%",
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              height: "100%",
            }}
          >
            <Grid
              container
              direction="row"
              alignItems="stretch"
              style={{
                height: "100%",
              }}
            >
              <Grid
                item
                style={{
                  width: "8%",
                }}
              >
                <Typography variant="body2">
                  <strong> Laptop </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid
                item
                style={{
                  width: "17%",
                }}
              >
                <Typography variant="body2">
                  <strong> Store </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid
                item
                style={{
                  width: "20%",
                }}
              >
                <Typography variant="body2">
                  <strong> Angle </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid
                item
                style={{
                  width: "15%",
                }}
              >
                <Typography variant="body2">
                  <strong> Product </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid
                item
                style={{
                  width: "8%",
                }}
              >
                <Typography variant="body2">
                  <strong> Media Buyer </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid
                item
                style={{
                  width: "8%",
                }}
              >
                <Typography
                  variant="body2"
                  style={{
                    float: "right",
                  }}
                >
                  <strong> Revenue </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              {/* <Grid item style={{ width: "15%" }}>
                                    <Typography variant="body2" style={{ float: "right" }}>
                                      <strong>Facebook</strong>
                                    </Typography>
                                  </Grid> */}{" "}
              <Grid
                item
                style={{
                  width: "8%",
                }}
              >
                <Typography
                  variant="body2"
                  style={{
                    float: "right",
                  }}
                >
                  <strong> Cost </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid
                item
                style={{
                  width: "8%",
                }}
              >
                <Typography
                  variant="body2"
                  style={{
                    float: "right",
                  }}
                >
                  <strong> Merchant </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid
                item
                style={{
                  width: "8%",
                }}
              >
                <Typography
                  variant="body2"
                  style={{
                    float: "right",
                  }}
                >
                  <strong> Profit </strong>{" "}
                </Typography>{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Divider variant="fullWidth" />
              </Grid>{" "}
              {stores.map((each, index) => {
                return (
                  <Grid item xs={12} key={index}>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      style={
                        index % 2 === 0
                          ? {
                              height: "100%",
                              backgroundColor: "#efefef",
                            }
                          : {
                              height: "100%",
                            }
                      }
                    >
                      <Grid
                        item
                        style={{
                          width: "8%",
                        }}
                      >
                        <Typography variant="body2"> {each.laptop} </Typography>{" "}
                      </Grid>{" "}
                      <Grid
                        item
                        style={{
                          width: "17%",
                        }}
                      >
                        <Typography variant="body2">
                          {" "}
                          {each.store_name}{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                      <Grid
                        item
                        style={{
                          width: "20%",
                        }}
                      >
                        <Typography variant="body2"> {each.angle} </Typography>{" "}
                      </Grid>{" "}
                      <Grid
                        item
                        style={{
                          width: "15%",
                        }}
                      >
                        <Typography variant="body2">
                          {" "}
                          {each.product_title[0]}{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                      <Grid
                        item
                        style={{
                          width: "8%",
                        }}
                      >
                        <Typography variant="body2">
                          {" "}
                          {each.media_buyer}{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                      <Grid
                        item
                        style={{
                          width: "8%",
                        }}
                      >
                        <Typography
                          variant="body2"
                          style={{
                            float: "right",
                          }}
                        >
                          {" "}
                          {each.revenue.toLocaleString("en", {
                            minimumFractionDigits: 2,
                          })}{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                      {/* <Grid item style={{ width: "15%" }}>
                                                        <Typography variant="body2" style={{ float: "right" }}>
                                                          {each.facebook.toLocaleString("en", {
                                                            minimumFractionDigits: 2,
                                                          })}
                                                        </Typography>
                                                      </Grid> */}{" "}
                      <Grid
                        item
                        style={{
                          width: "8%",
                        }}
                      >
                        <Typography
                          variant="body2"
                          style={{
                            float: "right",
                          }}
                        >
                          {" "}
                          {each.cost.toLocaleString("en", {
                            minimumFractionDigits: 2,
                          })}{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                      <Grid
                        item
                        style={{
                          width: "8%",
                        }}
                      >
                        <Typography
                          variant="body2"
                          style={{
                            float: "right",
                          }}
                        >
                          {" "}
                          {((each.revenue * 5.1) / 100)
                            .toFixed(2)
                            .toLocaleString("en", {
                              minimumFractionDigits: 2,
                            })}{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                      <Grid
                        item
                        style={{
                          width: "8%",
                        }}
                      >
                        <Typography
                          variant="body2"
                          style={{
                            float: "right",
                          }}
                        >
                          {" "}
                          {(
                            each.revenue -
                            // each.facebook -
                            each.cost -
                            ((each.revenue * 5.1) / 100).toFixed(2)
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                          })}{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Grid>
                );
              })}{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>
      ) : (
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
          style={{
            height: "80%",
          }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>{" "}
        </Grid>
      )}{" "}
    </Card>
  );
};

export default TopStores;
